import type { IconDefinition } from '../index.tsx';

export const iconDoorOpen: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconDoorOpen',
  icon: [
    16,
    16,
    [],
    '',
    'M15.5556 13.3231C15.7778 13.3231 16 13.5453 16 13.8231V14.6842C16 14.9065 15.7778 15.1009 15.5556 15.1009H12.4444V4.43424H9.77778V2.68424L12.8889 2.65646C13.6111 2.65646 14.2222 3.29535 14.2222 4.04535V13.3231H15.5556ZM7.77778 0.934237C8.33333 0.76757 8.88889 1.21201 8.88889 1.82313V15.1009H0.444444C0.194444 15.1009 0 14.9065 0 14.6287V13.7676C0 13.5453 0.194444 13.3231 0.444444 13.3231H1.77778V3.18424C1.77778 2.76757 2.02778 2.40646 2.44444 2.29535L7.77778 0.934237ZM6.44444 8.87868C6.80556 8.87868 7.11111 8.48979 7.11111 7.98979C7.11111 7.51757 6.80556 7.15646 6.44444 7.15646C6.05556 7.15646 5.77778 7.54535 5.77778 8.01757C5.77778 8.48979 6.05556 8.87868 6.44444 8.87868Z',
  ],
};
